import { RefObject } from 'react';
import { GRID_ROW_HEIGHT } from '../constants';

export const scrollGridToRow = (
  gridRef: RefObject<HTMLDivElement | any>,
  index: number
) => {
  if (!gridRef.current || index <= 0) return;

  const tableWrapper =
    gridRef.current.querySelector('.p-virtualscroller') ||
    gridRef.current.querySelector('.p-datatable-wrapper');

  if (!tableWrapper) return;
  tableWrapper.scrollTo({ top: index * GRID_ROW_HEIGHT, behavior: 'smooth' });
};
